import { getPblCases } from '@/api/pbl.api';
import type { PblCase } from '@/types/pbl';

const PAGE_SIZE = 50;
const PAGE_BATCH_SIZE = 4;

export const loadAllLawyerCases = async (status?: string): Promise<PblCase[]> => {
  const loadPage = async (page: number) => {
    const response = await getPblCases({ ...(status ? { status } : {}), per_page: PAGE_SIZE, page });
    if (response.data.success === false) {
      throw new Error(response.data.message || 'Failed to load cases.');
    }
    return response.data.data;
  };

  const first = await loadPage(1);
  const cases: PblCase[] = [...first.data];
  for (let start = 2; start <= first.last_page; start += PAGE_BATCH_SIZE) {
    const pageNumbers = Array.from(
      { length: Math.min(PAGE_BATCH_SIZE, first.last_page - start + 1) },
      (_, index) => start + index
    );
    const pages = await Promise.all(pageNumbers.map(loadPage));
    pages.forEach((page) => cases.push(...page.data));
  }

  return cases;
};
